<div mdbModal style="overflow-y: auto" #consultaDoc="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="width: 80%" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Consulta Movimiento de inventario
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="consultaDoc.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row align-items-center tipoMovimiento">
          <div class="col dato" style="max-width: 200px">
            <Strong class="title">Fecha de movimiento</Strong>
            <span class="value">{{movimiento?.fecha_creacion | fecha}}</span>
          </div>

          <div class="col dato" style="max-width: 200px">
            <Strong class="title">Nro. movimiento</Strong>
            <span class="value">{{movimiento?.codigo | numerico}}</span>
          </div>

          <div class="col dato" style="max-width: 200px">
            <Strong class="title">Bodega</Strong>
            <span class="value">{{movimiento?.bodega_nombre | numerico}}</span>
          </div>

          <div class="col dato" style="max-width: 200px">
            <Strong class="title">Estado</Strong>
            <span class="value">{{movimiento?.estado_inventario_nombre | numerico}}</span>
          </div>
        </div>

        <form autocomplete="off" [formGroup]="formHeader">
          <div class="row">
            <div class="col" style="max-width: 300px">
              <div class="md-form">
                <mdb-select [options]="optionsBodega" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
                  placeholder="Seleccionar Bodega" formControlName="bodega"></mdb-select>
                <label>Bodega</label>
              </div>
            </div>
            <div class="col" style="max-width: 300px">
              <div class="md-form">
                <mdb-select [options]="optionsEstado" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
                  placeholder="Seleccionar Estado" formControlName="estado"></mdb-select>
                <label>Estado</label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="referencia" class="form-control" placeholder="Referencia" required
                  #referencia formControlName="referencia" />
                <label for="rutcliente">Referencia</label>
              </div>
            </div>
          </div>
        </form>

        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">SKU</th>
              <th scope="col">Producto</th>
              <th scope="col">Formato</th>
              <th scope="col" class="text-right">Saldo Actual</th>
              <th scope="col" class="text-right">Inv. Físico</th>
              <th scope="col" class="text-right">Cant. Ent.</th>
              <th scope="col" class="text-right">Cant. Sal</th>
              <th scope="col" class="text-right">Precio</th>
              <th scope="col" class="text-right">Valor Dif.</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let doc of detalleDocumento">
              <td>{{doc.sku}}</td>
              <td>{{doc.producto_nombre}}</td>
              <td>{{doc.formato_nombre}}</td>
              <td class="text-right">{{doc.cantidad_saldo | numerico}}</td>
              <td class="text-right">{{doc.cantidad_contada | numerico}}</td>
              <td class="text-right">{{doc.cant_ent | numerico}}</td>
              <td class="text-right">{{doc.cant_sal | numerico}}</td>
              <td class="text-right">{{doc.precio_costo | numerico}}</td>
              <td class="text-right">{{doc.valor_dif | numerico}}</td>
            </tr>
          </tbody>
          <tbody class="blue lighten-5">
            <tr>
              <td lass="text-right" colspan="7">
                <span>
                  <strong>Cant. Prod.</strong>
                </span>
                <span>
                  {{cantidad | numerico}}
                </span>
              </td>
              <td class="text-right" colspan="1">
                <strong>Total Diferencia $</strong>
              </td>
              <td class="text-right">$ {{total_dif | numerico}}</td>
            </tr>
          </tbody>
          <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
            *ngIf="detalleDocumento?.length > 0"></app-pagination>
        </table>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="consultaDoc.hide()"
          mdbWavesEffect>
          Cerrar
        </button>
        <!-- <button type="button" class="btn btn-success waves-light" mdbWavesEffect (click)="print()">
          Imprimir
        </button> -->
        <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="downloadExcelPdf('XLS')">
          Excel
        </button>
      </div>
    </div>
  </div>
</div>